import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageHeader from 'components/PageHeader';
import PageFooter from 'components/PageFooter';
import styles from './style.module.scss';
const Page = ({ children }) => {
    return (_jsxs("div", { className: styles.page, children: [_jsx(PageHeader, {}), _jsx("main", { className: styles.main, children: _jsx("div", { className: "container", children: children }) }), _jsx(PageFooter, {})] }));
};
export default Page;
